import { Module } from 'wrapper6'

const $ = jQuery

export default class UnderTabs extends Module {
  ready (app) {
    this.addTabClicks()
  }

  addTabClicks () {
    const tabs = document.querySelectorAll('.mtt-under-tab__tab')
    const mobileBreakpoint = 580

    if (tabs.length) {
      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i]

        tab.addEventListener('click', () => {
          const id = tab.getAttribute('data-id')
          const wrapper = this.findAncestor(tab, '.mtt-under-tab')
          const content = this.findAncestor(tab, '.page_container').nextElementSibling

          wrapper.querySelector('.mtt-under-tab__tab.active').classList.remove('active')

          tab.classList.add('active')

          wrapper.querySelector('.mtt-under-tab__widget:not(.hide)').classList.add('hide')

          wrapper.querySelector('.mtt-under-tab__widget[data-id="' + id + '"]').classList.remove('hide')

          if (window.innerWidth <= mobileBreakpoint) {
            this.scrollToContent(content)
          }
        })
      }
    }
  }

  scrollToContent (content) {
    if (content) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(content).offset().top - 100
      }, 500)
    }
  }

  findAncestor (el, selector) {
    let parent_container = el
    do {
      parent_container = parent_container.parentNode
    }
    while (!parent_container.matches(selector) && parent_container !== document.body)

    return parent_container
  }
}
